// @ts-nocheck

import i18next from 'i18next'
import get from 'lodash/get'
import * as yup from 'yup'
import { mixed, number, object, string } from 'yup'

import { UsPhoneCode } from '../src/helpers/constants'

const usPhoneNumberRegEx = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/
const nonUsPhoneNumberRegEx = /^[0-9]{8,15}$/

const specialCharacters = /^[a-zA-Z0-9_ .-]+$/
export const emailRegexWithAlias = /^\s*[\w.]+@([\w]+\.)+[\w]{2,4}\s*$/
const alphaNumeric = /^[a-zA-Z0-9-_. ]*$/

export const Authchema = {
  registeration: object({
    email: string()
      .email('error:email')
      .test('email', 'error:maxLength65', (value) => {
        return !value || value.length <= 65
      })
      .required('error:required'),
    password: string()
      .test('password', 'error:minLength8', (value) => {
        return !value || value.length >= 8
      })
      .test('password', 'error:maxLength20', (value) => {
        return !value || value.length <= 20
      })
      .test('password', 'error:errorPasswordTestLowerCase', (value) => {
        return !value || value.toUpperCase() !== value
      })
      .test('password', 'error:errorPasswordTestUpperCase', (value) => {
        return !value || value.toLowerCase() !== value
      })
      .test('password', 'error:errorPasswordTestDigit', (value) => {
        return !value || /\d/.test(value)
      })
      .test('password', 'error:errorPasswordTestSpecial', (value) => {
        return !value || !/^[A-Za-z0-9 ]+$/.test(value)
      })
      .when('email', {
        is: (val) => (val ? true : false),
        then: yup.string().notOneOf([yup.ref('email'), null], 'error:errorPasswordTestEmailMatch'),
      })
      .required('error:required'),
    confirmPassword: string()
      .oneOf([yup.ref('password'), null], 'error:errorPasswordConfirmNotMatch')
      .required('error:required'),
  }),
  updatePassword: object({
    current_password: string().required('error:required'),
    new_password: string()
      .test('new_password', 'error:minLength8', (value) => {
        return !value || value.length >= 8
      })
      .test('new_password', 'error:maxLength20', (value) => {
        return !value || value.length <= 20
      })
      .test('new_password', 'error:errorPasswordTestLowerCase', (value) => {
        return !value || value.toUpperCase() !== value
      })
      .test('new_password', 'error:errorPasswordTestUpperCase', (value) => {
        return !value || value.toLowerCase() !== value
      })
      .test('new_password', 'error:errorPasswordTestDigit', (value) => {
        return !value || /\d/.test(value)
      })
      .test('new_password', 'error:errorPasswordTestSpecial', (value) => {
        return !value || !/^[A-Za-z0-9 ]+$/.test(value)
      })
      // .notOneOf([yup.ref('current_password'), null], 'error:errorCurrentPasswordConfirmMatch')
      .required('error:required'),
    confirm_password: string()
      .oneOf([yup.ref('new_password'), null], 'error:errorPasswordConfirmNotMatch')
      .required('error:required'),
  }),
}

export const CoreSchema = {
  studentInfo: object({
    first_name: string('error:stringError')
      .trim('error:errorSpace')
      .test('first_name', 'error:minLength2', (value) => {
        return !value || value.length >= 2
      })
      .test('first_name', 'error:maxLength26', (value) => {
        return !value || value.length <= 26
      })
      .required('error:required'),
    last_name: string('error:stringError')
      .trim('error:errorSpace')
      .test('last_name', 'error:minLength2', (value) => {
        return !value || value.length >= 2
      })
      .test('last_name', 'error:maxLength26', (value) => {
        return !value || value.length <= 26
      })
      .required('error:required'),
    dob: string('error:stringError').required('error:required').nullable(),
    address: object().shape({
      adr_country_iso: string('error:stringError').required('error:required'),
      adr_state_iso: string('error:stringError')
        .trim('error:errorSpace')
        .required('error:required'),
      adr_city: string('error:stringError')
        .trim('error:errorSpace')
        .test('adr_city', 'error:maxLength50', (value) => {
          return !value || value.length <= 50
        })
        .required('error:required'),
      adr_zipcode: string('error:stringError')
        .trim('error:errorSpace')
        .test('adr_zipcode', 'error:maxLength10', (value) => {
          return !value || value.length <= 10
        })
        .required('error:required'),
      adr_address1: string('error:stringError')
        .trim('error:errorSpace')
        .test('adr_address1', 'error:maxLength100', (value) => {
          return !value || value.length <= 100
        })
        .required('error:required'),
      adr_address2: string('error:stringError')
        .trim('error:errorSpace')
        .test('adr_address2', 'error:maxLength100', (value) => {
          return !value || value.length <= 100
        }),
      adr_mobile: string().when('adr_mobile_prefix', {
        is: (val) => !val || val === UsPhoneCode,
        then: string().test(
          'adr_mobile',
          'error:validPhone',
          (value) => !value || usPhoneNumberRegEx.test(value)
        ),
        otherwise: string().test(
          'adr_mobile',
          'error:validPhone',
          (value) => !value || nonUsPhoneNumberRegEx.test(value)
        ),
      }),
    }),
    parents: object().when('parent_info_validation', {
      is: true,
      then: object({
        email: string('error:stringError')
          .trim('error:errorSpace')
          .email('error:email')
          .test('email', 'error:maxLength65', (value) => {
            return !value || value.length <= 65
          })
          .required('error:required'),
        prefix: string('error:stringError'),
        first_name: string('error:stringError')
          .trim('error:errorSpace')
          .test('first_name', 'error:minLength2', (value) => {
            return !value || value.length >= 2
          })
          .test('first_name', 'error:maxLength26', (value) => {
            return !value || value.length <= 20
          })
          .required('error:required'),
        middle_name: string('error:stringError')
          .trim('error:errorSpace')
          .test('first_name', 'error:minLength2', (value) => {
            return !value || value.length >= 2
          })
          .test('first_name', 'error:maxLength26', (value) => {
            return !value || value.length <= 26
          }),
        last_name: string('error:stringError')
          .trim('error:errorSpace')
          .test('first_name', 'error:minLength2', (value) => {
            return !value || value.length >= 2
          })
          .test('first_name', 'error:maxLength26', (value) => {
            return !value || value.length <= 26
          })
          .required('error:required'),
        dob: string('error:stringError').required('error:required').nullable(),
        suffix: string('error:stringError'),
        nick_name: string('error:stringError')
          .trim('error:errorSpace')
          .test('first_name', 'error:minLength2', (value) => {
            return !value || value.length >= 2
          })
          .test('first_name', 'error:maxLength26', (value) => {
            return !value || value.length <= 26
          }),
        primary_phone_number: string().when('primary_phone_number_prefix', {
          is: (val) => !val || val === UsPhoneCode,
          then: string()
            .required('error:required')
            .test(
              'primary_phone_number',
              'error:validPhone',
              (value) => !value || usPhoneNumberRegEx.test(value)
            ),
          otherwise: string()
            .required('error:required')
            .test(
              'primary_phone_number',
              'error:validPhone',
              (value) => !value || nonUsPhoneNumberRegEx.test(value)
            ),
        }),
        home_phone_number: string().when('home_phone_number_prefix', {
          is: (val) => !val || val === UsPhoneCode,
          then: string().test(
            'home_phone_number',
            'error:validPhone',
            (value) => !value || usPhoneNumberRegEx.test(value)
          ),
          otherwise: string().test(
            'home_phone_number',
            'error:validPhone',
            (value) => !value || nonUsPhoneNumberRegEx.test(value)
          ),
        }),
        relationship_with_student: string('error:stringError').required('error:required'),
      }),
    }),
  }),
  guestStudentInfo: object({
    first_name: string('error:stringError')
      .trim('error:errorSpace')
      .test('first_name', 'error:minLength2', (value) => {
        return !value || value.length >= 2
      })
      .test('first_name', 'error:maxLength26', (value) => {
        return !value || value.length <= 26
      })
      .required('error:required'),
    last_name: string('error:stringError')
      .trim('error:errorSpace')
      .test('last_name', 'error:minLength2', (value) => {
        return !value || value.length >= 2
      })
      .test('last_name', 'error:maxLength26', (value) => {
        return !value || value.length <= 26
      })
      .required('error:required'),
    dob: string('error:stringError').required('error:required').nullable(),
    gender: string('error:stringError').required('error:required'),
    email: string('error:stringError')
      .trim('error:errorSpace')
      .email('error:email')
      .test('email', 'error:maxLength65', (value) => {
        return !value || value.length <= 65
      })
      .required('error:required'),
    address: object().shape({
      adr_country_iso: string('error:stringError').required('error:required'),
      adr_state_iso: string('error:stringError')
        .trim('error:errorSpace')
        .required('error:required'),
      adr_city: string('error:stringError')
        .trim('error:errorSpace')
        .test('adr_city', 'error:maxLength50', (value) => {
          return !value || value.length <= 50
        })
        .required('error:required'),
      adr_zipcode: string('error:stringError')
        .trim('error:errorSpace')
        .test('adr_zipcode', 'error:maxLength10', (value) => {
          return !value || value.length <= 10
        })
        .required('error:required'),
      adr_address1: string('error:stringError')
        .trim('error:errorSpace')
        .required('error:required')
        .test('adr_address1', 'error:maxLength100', (value) => {
          return !value || value.length <= 100
        }),

      adr_address2: string('error:stringError')
        .trim('error:errorSpace')
        .test('adr_address2', 'error:maxLength100', (value) => {
          return !value || value.length <= 100
        }),
      adr_mobile: string()
        .when('adr_mobile_prefix', {
          is: (val) => !val || val === UsPhoneCode,
          then: string().test(
            'adr_mobile',
            'error:validPhone',
            (value) => !value || usPhoneNumberRegEx.test(value)
          ),
          otherwise: string().test(
            'adr_mobile',
            'error:validPhone',
            (value) => !value || nonUsPhoneNumberRegEx.test(value)
          ),
        })
        .required('error:required'),
    }),
    add_fee_guest_remark: string('error:stringError').test(
      'add_fee_guest_remark',
      'error:maxLength1000',
      (value) => {
        return !value || value.length <= 1000
      }
    ),
  }),

  studentInfoFormPart: object({
    // prefix: string('error:stringError').required('error:required'),
    first_name: string('error:stringError')
      .trim('error:errorSpace')
      .test('first_name', 'error:minLength2', (value) => {
        return !value || value.length >= 2
      })
      .test('first_name', 'error:maxLength26', (value) => {
        return !value || value.length <= 26
      })
      .required('error:required'),
    middle_name: string('error:stringError')
      .trim('error:errorSpace')
      .test('first_name', 'error:minLength2', (value) => {
        return !value || value.length >= 2
      })
      .test('first_name', 'error:maxLength26', (value) => {
        return !value || value.length <= 26
      }),
    last_name: string('error:stringError')
      .trim('error:errorSpace')
      .test('first_name', 'error:minLength2', (value) => {
        return !value || value.length >= 2
      })
      .test('first_name', 'error:maxLength26', (value) => {
        return !value || value.length <= 26
      })
      .required('error:required'),
    suffix: string('error:stringError'),
    nick_name: string('error:stringError')
      .trim('error:errorSpace')
      .test('first_name', 'error:minLength2', (value) => {
        return !value || value.length >= 2
      })
      .test('first_name', 'error:maxLength26', (value) => {
        return !value || value.length <= 26
      }),
    dob: string('error:stringError').required('error:required').nullable(),
    gender: string('error:stringError').required('error:required'),
    ethnicity: string('error:stringError').required('error:required'),
    adr_address1: string('error:stringError')
      .trim('error:errorSpace')
      .test('adr_address1', 'error:maxLength100', (value) => {
        return !value || value.length <= 100
      })
      .required('error:required'),
    adr_address2: string('error:stringError')
      .trim('error:errorSpace')
      .test('adr_address2', 'error:maxLength100', (value) => {
        return !value || value.length <= 100
      }),
    adr_country_iso: string('error:stringError').required('error:required'),
    adr_state_iso: string('error:stringError').trim('error:errorSpace').required('error:required'),
    adr_city: string('error:stringError')
      .trim('error:errorSpace')
      .test('adr_city', 'error:maxLength50', (value) => {
        return !value || value.length <= 50
      })
      .required('error:required'),
    adr_zipcode: string('error:stringError')
      .trim('error:errorSpace')
      .test('adr_zipcode', 'error:maxLength10', (value) => {
        return !value || value.length <= 10
      })
      .required('error:required'),
    email: string('error:stringError')
      .trim('error:errorSpace')
      .test('email', 'error:maxLength65', (value) => {
        return !value || value.length <= 65
      })
      .required('error:required'),
    adr_mobile: string().when('adr_mobile_prefix', {
      is: (val) => !val || val === UsPhoneCode,
      then: yup
        .string()
        .required('error:required')
        .test(
          'adr_mobile',
          'error:validPhone',
          (value) => !value || usPhoneNumberRegEx.test(value)
        ),
      otherwise: yup
        .string()
        .required('error:required')
        .test(
          'adr_mobile',
          'error:validPhone',
          (value) => !value || nonUsPhoneNumberRegEx.test(value)
        ),
    }),
    adr_phone: string().when('adr_phone_prefix', {
      is: (val) => !val || val === UsPhoneCode,
      then: yup
        .string()
        .test('adr_phone', 'error:validPhone', (value) => !value || usPhoneNumberRegEx.test(value)),
      otherwise: yup
        .string()
        .test(
          'adr_phone',
          'error:validPhone',
          (value) => !value || nonUsPhoneNumberRegEx.test(value)
        ),
    }),
    upload_id_file: mixed()
      // .test('required', 'message:required', (value) => {
      //   return !!value
      // })
      .test('upload_id_file', 'error:errorFileSize', (value) => {
        return !value || value.size <= 10240000
      })
      .test(
        'fileType',
        'error:errorFileTypesPDDJJPT',
        (value) =>
          !value ||
          ['pdf', 'doc', 'docx', 'jpg', 'jpeg', 'png', 'txt'].includes(
            get(value, 'name', '').substr(get(value, 'name', '').lastIndexOf('.') + 1)
          )
      ),
  }),
  updateParentProfile: object({
    dob: string('error:stringError').required('error:required').nullable(),
    middle_name: string('error:stringError')
      .trim('error:errorSpace')
      .test('first_name', 'error:minLength2', (value) => {
        return !value || value.length >= 2
      })
      .test('first_name', 'error:maxLength26', (value) => {
        return !value || value.length <= 26
      }),
    suffix: string('error:stringError'),
    nick_name: string('error:stringError')
      .trim('error:errorSpace')
      .test('first_name', 'error:minLength2', (value) => {
        return !value || value.length >= 2
      })
      .test('first_name', 'error:maxLength26', (value) => {
        return !value || value.length <= 26
      }),
    gender: string('error:stringError').required('error:required'),
    ethnicity: string('error:stringError').required('error:required'),
  }),
  updateProfile: object({
    middle_name: string('error:stringError')
      .trim('error:errorSpace')
      .test('first_name', 'error:minLength2', (value) => {
        return !value || value.length >= 2
      })
      .test('first_name', 'error:maxLength26', (value) => {
        return !value || value.length <= 26
      }),
    suffix: string('error:stringError'),
    nick_name: string('error:stringError')
      .trim('error:errorSpace')
      .test('first_name', 'error:minLength2', (value) => {
        return !value || value.length >= 2
      })
      .test('first_name', 'error:maxLength26', (value) => {
        return !value || value.length <= 26
      }),
    gender: string('error:stringError').required('error:required'),
    ethnicity: string('error:stringError').required('error:required'),

    adr_mobile: string().when('adr_mobile_prefix', {
      is: (val) => !val || val === UsPhoneCode,
      then: yup
        .string()
        .required('error:required')
        .test(
          'adr_mobile',
          'error:validPhone',
          (value) => !value || usPhoneNumberRegEx.test(value)
        ),
      otherwise: yup
        .string()
        .required('error:required')
        .test(
          'adr_mobile',
          'error:validPhone',
          (value) => !value || nonUsPhoneNumberRegEx.test(value)
        ),
    }),
    adr_phone: string().when('adr_phone_prefix', {
      is: (val) => !val || val === UsPhoneCode,
      then: yup
        .string()
        .test('adr_phone', 'error:validPhone', (value) => !value || usPhoneNumberRegEx.test(value)),
      otherwise: yup
        .string()
        .test(
          'adr_phone',
          'error:validPhone',
          (value) => !value || nonUsPhoneNumberRegEx.test(value)
        ),
    }),
    upload_id_file: mixed()
      // .test('required', 'message:required', (value) => {
      //   return !!value
      // })
      .test('upload_id_file', 'error:errorFileSize', (value) => {
        return !value || value.size <= 10240000
      })
      .test(
        'fileType',
        'error:errorFileTypesPDDJJPT',
        (value) =>
          !value ||
          ['pdf', 'doc', 'docx', 'jpg', 'jpeg', 'png', 'txt'].includes(
            get(value, 'name', '').substr(get(value, 'name', '').lastIndexOf('.') + 1)
          )
      ),
  }),
  parentInfoFormPart: object({
    // prefix: string('error:stringError').required('error:required'),
    first_name: string('error:stringError')
      .trim('error:errorSpace')
      .test('first_name', 'error:minLength2', (value) => {
        return !value || value.length >= 2
      })
      .test('first_name', 'error:maxLength26', (value) => {
        return !value || value.length <= 26
      })
      .required('error:required'),
    middle_name: string('error:stringError')
      .trim('error:errorSpace')
      .test('first_name', 'error:minLength2', (value) => {
        return !value || value.length >= 2
      })
      .test('first_name', 'error:maxLength26', (value) => {
        return !value || value.length <= 26
      }),
    last_name: string('error:stringError')
      .trim('error:errorSpace')
      .test('first_name', 'error:minLength2', (value) => {
        return !value || value.length >= 2
      })
      .test('first_name', 'error:maxLength26', (value) => {
        return !value || value.length <= 26
      })
      .required('error:required'),
    suffix: string('error:stringError'),
    nick_name: string('error:stringError')
      .trim('error:errorSpace')
      .test('first_name', 'error:minLength2', (value) => {
        return !value || value.length >= 2
      })
      .test('first_name', 'error:maxLength26', (value) => {
        return !value || value.length <= 26
      }),
    dob: string('error:stringError').required('error:required').nullable(),
    gender: string('error:stringError').required('error:required'),
    ethnicity: string('error:stringError').required('error:required'),
    adr_address1: string('error:stringError')
      .trim('error:errorSpace')
      .test('adr_address1', 'error:maxLength100', (value) => {
        return !value || value.length <= 100
      })
      .required('error:required'),
    adr_address2: string('error:stringError')
      .trim('error:errorSpace')
      .test('adr_address2', 'error:maxLength100', (value) => {
        return !value || value.length <= 100
      }),
    adr_country_iso: string('error:stringError').required('error:required'),
    adr_state_iso: string('error:stringError').trim('error:errorSpace').required('error:required'),
    adr_city: string('error:stringError')
      .trim('error:errorSpace')
      .test('adr_city', 'error:maxLength50', (value) => {
        return !value || value.length <= 50
      })
      .required('error:required'),
    adr_zipcode: string('error:stringError')
      .trim('error:errorSpace')
      .test('adr_zipcode', 'error:maxLength10', (value) => {
        return !value || value.length <= 10
      })
      .required('error:required'),
    email: string('error:stringError')
      .trim('error:errorSpace')
      .test('email', 'error:maxLength65', (value) => {
        return !value || value.length <= 65
      })
      .required('error:required'),
    adr_mobile: string().when('adr_mobile_prefix', {
      is: (val) => !val || val === UsPhoneCode,
      then: yup
        .string()
        .required('error:required')
        .test(
          'adr_mobile',
          'error:validPhone',
          (value) => !value || usPhoneNumberRegEx.test(value)
        ),
      otherwise: yup
        .string()
        .required('error:required')
        .test(
          'adr_mobile',
          'error:validPhone',
          (value) => !value || nonUsPhoneNumberRegEx.test(value)
        ),
    }),
    adr_phone: string().when('adr_phone_prefix', {
      is: (val) => !val || val === UsPhoneCode,
      then: yup
        .string()
        .test('adr_phone', 'error:validPhone', (value) => !value || usPhoneNumberRegEx.test(value)),
      otherwise: yup
        .string()
        .test(
          'adr_phone',
          'error:validPhone',
          (value) => !value || nonUsPhoneNumberRegEx.test(value)
        ),
    }),
    upload_id_file: mixed()
      // .test('required', 'message:required', (value) => {
      //   return !!value
      // })
      .test('upload_id_file', 'error:errorFileSize', (value) => {
        return !value || value.size <= 10240000
      })
      .test(
        'fileType',
        'error:errorFileTypesPDDJJPT',
        (value) =>
          !value ||
          ['pdf', 'doc', 'docx', 'jpg', 'jpeg', 'png', 'txt'].includes(
            get(value, 'name', '').substr(get(value, 'name', '').lastIndexOf('.') + 1)
          )
      ),
    security_question: string('error:stringError').required('error:required'),
    security_answer: string('error:stringError')
      .trim('error:errorSpace')
      .test('security_answer', 'error:maxLength40', (value) => {
        return !value || value.length <= 40
      })
      .required('error:required'),
  }),
  studentInfoFormPart1: object({
    // prefix: string('error:stringError').required('error:required'),
    first_name: string('error:stringError')
      .test('first_name', 'error:minLength2', (value) => {
        return !value || value.length >= 2
      })
      .trim('error:errorSpace')
      .test('first_name', 'error:maxLength26', (value) => {
        return !value || value.length <= 26
      })
      .required('error:required'),
    middle_name: string('error:stringError')
      .test('first_name', 'error:minLength2', (value) => {
        return !value || value.length >= 2
      })
      .trim('error:errorSpace')
      .test('first_name', 'error:maxLength26', (value) => {
        return !value || value.length <= 26
      }),
    last_name: string('error:stringError')
      .test('first_name', 'error:minLength2', (value) => {
        return !value || value.length >= 2
      })
      .trim('error:errorSpace')
      .test('first_name', 'error:maxLength26', (value) => {
        return !value || value.length <= 26
      })
      .required('error:required'),
    suffix: string('error:stringError'),
    nick_name: string('error:stringError')
      .test('first_name', 'error:minLength2', (value) => {
        return !value || value.length >= 2
      })
      .trim('error:errorSpace')
      .test('first_name', 'error:maxLength26', (value) => {
        return !value || value.length <= 26
      }),
    dob: string('error:stringError').required('error:required'),
    gender: string('error:stringError').required('error:required'),
    ethnicity: string('error:stringError').required('error:required'),
  }),

  studentInfoFormPart2: object({
    adr_address1: string('error:stringError')
      .test('adr_address1', 'error:maxLength100', (value) => {
        return !value || value.length <= 100
      })
      .trim('error:errorSpace')
      .required('error:required'),
    adr_address2: string('error:stringError')
      .trim('error:errorSpace')
      .test('adr_address2', 'error:maxLength100', (value) => {
        return !value || value.length <= 100
      }),
    adr_country_iso: string('error:stringError').required('error:required'),
    adr_state_iso: string('error:stringError').required('error:required'),
    adr_city: string('error:stringError')
      .test('adr_city', 'error:maxLength100', (value) => {
        return !value || value.length <= 100
      })
      .trim('error:errorSpace')
      .required('error:required'),
    adr_zipcode: string('error:stringError')
      .test('adr_zipcode', 'error:maxLength10', (value) => {
        return !value || value.length <= 10
      })
      .trim('error:errorSpace')
      .required('error:required'),
    email: string('error:stringError')
      .test('email', 'error:maxLength65', (value) => {
        return !value || value.length <= 65
      })
      .trim('error:errorSpace')
      .required('error:required'),
    adr_mobile: string().when('adr_mobile_prefix', {
      is: (val) => !val || val === UsPhoneCode,
      then: yup
        .string()
        .test(
          'adr_mobile',
          'error:validPhone',
          (value) => !value || usPhoneNumberRegEx.test(value)
        ),
      otherwise: yup
        .string()
        .test(
          'adr_mobile',
          'error:validPhone',
          (value) => !value || nonUsPhoneNumberRegEx.test(value)
        ),
    }),
    adr_phone: string().when('adr_phone_prefix', {
      is: (val) => !val || val === UsPhoneCode,
      then: yup
        .string()
        .test('adr_phone', 'error:validPhone', (value) => !value || usPhoneNumberRegEx.test(value)),
      otherwise: yup
        .string()
        .test(
          'adr_phone',
          'error:validPhone',
          (value) => !value || nonUsPhoneNumberRegEx.test(value)
        ),
    }),
  }),
  studentInfoFormPart3: object({
    upload_id_file: mixed()
      .test('upload_id_file', 'error:errorFileSize', (value) => {
        return !value || value.size <= 10240000
      })
      .test(
        'fileType',
        'error:errorFileTypesPDDJJPT',
        (value) =>
          !value ||
          ['pdf', 'doc', 'docx', 'jpg', 'jpeg', 'png', 'txt'].includes(
            get(value, 'name', '').substr(get(value, 'name', '').lastIndexOf('.') + 1)
          )
      ),
    upload_id_type: string('error:stringError').when('upload_id_file', {
      is: (val) => {
        return val ? true : false
      },
      then: yup.string().required('error:required'),
    }),
    security_question: string('error:stringError').required('error:required'),
    security_answer: string('error:stringError')
      .test('security_answer', 'error:maxLength40', (value) => {
        return !value || value.length <= 40
      })
      .required('error:required'),
  }),
  updateSecurityQuestions: object({
    security_question: string('error:stringError').required('error:required'),
    security_answer: string('error:stringError')
      .test('security_answer', 'error:maxLength40', (value) => {
        return !value || value.length <= 40
      })
      .required('error:required'),
  }),
  updateUserNamePassword: object({
    password: string().required('error:required'),
  }),
  parentInfoForm: object({
    email: string('error:stringError')
      .trim('error:errorSpace')
      .email('error:email')
      .test('email', 'error:maxLength65', (value) => {
        return !value || value.length <= 65
      })
      .required('error:required'),
    prefix: string('error:stringError'),
    first_name: string('error:stringError')
      .trim('error:errorSpace')
      .test('first_name', 'error:minLength2', (value) => {
        return !value || value.length >= 2
      })
      .test('first_name', 'error:maxLength26', (value) => {
        return !value || value.length <= 20
      })
      .required('error:required'),
    middle_name: string('error:stringError')
      .trim('error:errorSpace')
      .test('first_name', 'error:minLength2', (value) => {
        return !value || value.length >= 2
      })
      .test('first_name', 'error:maxLength26', (value) => {
        return !value || value.length <= 26
      }),
    last_name: string('error:stringError')
      .trim('error:errorSpace')
      .test('first_name', 'error:minLength2', (value) => {
        return !value || value.length >= 2
      })
      .test('first_name', 'error:maxLength26', (value) => {
        return !value || value.length <= 26
      })
      .required('error:required'),
    suffix: string('error:stringError'),
    nick_name: string('error:stringError')
      .trim('error:errorSpace')
      .test('first_name', 'error:minLength2', (value) => {
        return !value || value.length >= 2
      })
      .test('first_name', 'error:maxLength26', (value) => {
        return !value || value.length <= 26
      }),
    primary_phone_number: string().when('primary_phone_number_prefix', {
      is: (val) => !val || val === UsPhoneCode,
      then: yup
        .string()
        .required('error:required')
        .test(
          'primary_phone_number',
          'error:validPhone',
          (value) => !value || usPhoneNumberRegEx.test(value)
        ),
      otherwise: yup
        .string()
        .required('error:required')
        .test(
          'primary_phone_number',
          'error:validPhone',
          (value) => !value || nonUsPhoneNumberRegEx.test(value)
        ),
    }),
    home_phone_number: string().when('home_phone_number_prefix', {
      is: (val) => !val || val === UsPhoneCode,
      then: yup
        .string()
        .test(
          'home_phone_number',
          'error:validPhone',
          (value) => !value || usPhoneNumberRegEx.test(value)
        ),
      otherwise: yup
        .string()
        .test(
          'home_phone_number',
          'error:validPhone',
          (value) => !value || nonUsPhoneNumberRegEx.test(value)
        ),
    }),
    relationship_with_student: string('error:stringError').required('error:required'),
  }),
  essayForm: object({
    essay: string('error:stringError').required('error:required'),
  }),
  enrollmentTnCForm: object({
    is_iep: string('error:stringError').required('error:required'),
    last_grade: string('error:stringError')
      .trim('error:errorSpace')
      .test('last_grade', 'error:specialCharacter', (value) => {
        return !value || specialCharacters.test(value)
      }),
  }),
  addWalletPointForm: object({
    amount: string()
      .required('message:required')
      .test('amount', 'message:numberError', (value) => {
        return !value || !isNaN(value)
      }),
  }),
  reviewMandatory: object({
    review: string('error:stringError')
      .transform((value) => value.trim())

      .test('review', 'error:minLength30', (value) => {
        return !value || value.length >= 30
      })
      .test('review', 'error:maxLength1000', (value) => {
        return !value || value.length <= 1000
      })
      .required('error:required'),
    // rating: string().required('message:required'),
  }),
  review: object({
    review: string('error:stringError')
      .transform((value) => value.trim())

      .max(...[1000, i18next.t('error:maxLength', { length: 1000 })])
      .trim('error:errorSpace'),
    // rating: string().required('message:required'),
  }),
  ////////////////////////////////////////////////////////////////---Files Validations---///////////////////////////////////////////////////////////////////////////
  uploadFiles: object({
    fl_file_name: string('error:stringError')
      .required('error:required')
      .max(50, 'error:maxLength50'),
    fl_file_alias_name: string('error:stringError')
      .min(...[2, i18next.t('error:minLength', { length: 2 })])
      .max(...[50, i18next.t('error:maxLength', { length: 50 })]),
    // fl_description: string('error:stringError')
    //   .test('fl_description', 'error:minLength10', (value) => {
    //     return !value || value.length >= 10
    //   })
    //   .test('fl_description', 'error:maxLength1000', (value) => {
    //     return !value || value.length <= 1000
    //   }),
    file: mixed()
      .required('error:required')
      .test('file', 'error:errorFileSize30MB', (value) => {
        return !value || value.size <= 30720000
      })
      .test('file', 'error:errorFileTypesPDDJJPTXXC', (value) => {
        const fileTypes = ['pdf', 'doc', 'docx', 'jpg', 'jpeg', 'png', 'txt', 'xlsx', 'xls', 'csv']
        return fileTypes.includes(
          (
            get(value, 'name', '').substr(get(value, 'name', '').lastIndexOf('.') + 1) || ''
          ).toLowerCase()
        )
      }),
  }),
  ferpaFor: object({
    frp_name: string('error:stringError')
      .trim('error:errorSpace')
      .test('frp_name', 'error:minLength2', (value) => {
        return !value || value.length >= 2
      })
      .test('frp_name', 'error:maxLength100', (value) => {
        return !value || value.length <= 100
      })
      .required('error:required'),
    frp_relation: string('error:stringError')
      .trim('error:errorSpace')
      .required('error:required')
      .test('frp_relation', 'error:minLength2', (value) => {
        return !value || value.length >= 2
      })
      .test('frp_relation', 'error:maxLength100', (value) => {
        return !value || value.length <= 100
      }),
    frp_address_1: string('error:stringError')
      .trim('error:errorSpace')
      .test('frp_address_1', 'error:maxLength100', (value) => {
        return !value || value.length <= 100
      })
      .required('error:required'),
    frp_address_2: string('error:stringError')
      .trim('error:errorSpace')
      .test('frp_address_2', 'error:maxLength100', (value) => {
        return !value || value.length <= 100
      }),
    frp_city: string('error:stringError')
      .trim('error:errorSpace')
      .test('frp_city', 'error:maxLength100', (value) => {
        return !value || value.length <= 100
      })
      .required('error:required'),
    frp_country_iso: string('error:stringError').required('error:required'),
    frp_state: string('error:stringError').trim('error:errorSpace').required('error:required'),
    frp_zip: string()
      // .typeError('error:numberError')
      .max(...[10, i18next.t('error:maxLength', { length: 10 })])
      .test('frp_zip', 'error:validAlphaNumeric', (value) => {
        return alphaNumeric.test(value)
      })
      .required('error:required'),
    frp_email: string('error:stringError')
      .email('error:email')
      .trim('error:errorSpace')
      .test('frp_email', 'error:maxLength65', (value) => {
        return !value || value.length <= 65
      })
      .required('error:required'),
    frp_phone: string().when('frp_phone_prefix', {
      is: (val) => !val || val === UsPhoneCode,
      then: yup
        .string()
        .required('error:required')
        .test('frp_phone', 'error:validPhone', (value) => !value || usPhoneNumberRegEx.test(value)),
      otherwise: yup
        .string()
        .test(
          'frp_phone',
          'error:validPhone',
          (value) => !value || nonUsPhoneNumberRegEx.test(value)
        ),
    }),
  }),
  tms: object({
    title: string('error:stringError').trim('error:errorSpace').required('error:required'),
    description: string('error:stringError').trim('error:errorSpace').required('error:required'),
    media: mixed()
      .test('media', 'message:errorFileSize4MB', (value) => {
        const initialValue = 0
        const sum = value.reduce(function (accumulator, curValue) {
          return accumulator + curValue.size
        }, initialValue)
        const flag = isNaN(sum) || sum <= 4194304
        return flag
      })
      .test(
        'media',
        'error:errorFileTypesPJXDP',
        (value) =>
          !value ||
          value.every((file) =>
            ['pdf', 'jpg', 'png', 'xlsx', 'docx'].includes(
              get(file, 'name', '').substr(get(file, 'name', '').lastIndexOf('.') + 1)
            )
          )
      ),
  }),
  reEnroll: object({
    re_enr_course_type: string('error:stringError')
      .trim('error:errorSpace')
      .required('error:required'),
    re_enr_requested_grade: string('error:stringError').trim('error:errorSpace'),
    re_enr_remark: string('error:stringError')
      .trim('error:errorSpace')
      .min(...[10, i18next.t('error:minLength', { length: 10 })]),
    re_enr_tentative_date: string('error:stringError'),
  }),
  dropEnrollment: object({
    end_request_type: yup.array().min(1, 'error:required'),
    end_reason: yup.array().min(1, 'error:required'),
    end_notes: string('error:stringError')
      .transform((value) => value.trim())

      .test('end_notes', 'error:minLength5', (value) => {
        return !value || value.length >= 5
      })
      .test('end_notes', 'error:maxLength1000', (value) => {
        return !value || value.length <= 1000
      })
      .required('error:required'),
  }),
  smsSetting: object({
    otp: number().typeError('error:numberError').required('error:required'),
    mobile_no: string().when('mobile_prefix', {
      is: (val) => !val || val === UsPhoneCode,
      then: yup
        .string()
        .required('error:required')
        .test('mobile_no', 'error:validPhone', (value) => !value || usPhoneNumberRegEx.test(value)),
      otherwise: yup
        .string()
        .required('error:required')
        .test(
          'mobile_no',
          'error:validPhone',
          (value) => !value || nonUsPhoneNumberRegEx.test(value)
        ),
    }),
  }),
}
